import PillCell from '../components/organisms/Table/Cells/Pill'
import { ColumnConfig } from '../types/tables'

const analysisColumns: ColumnConfig[] = [
  { name: 'Estatus', key: 'status', sort: true, width: '10%', component: PillCell },
  { name: 'Banco', key: 'bank', sort: true, width: '10%' },
  { name: 'Cliente', key: 'client', sort: true, width: '20%' },
  { name: 'Banco Pagador', key: 'bankPayer', sort: true, width: '10%' },
  { name: 'Monto', key: 'total', sort: true, width: '10%', sortFunction: (a: any, b: any) => {
      const crediAmountA = parseFloat(a.total.replace(/[$|,]/g, ''))
      const creditAmountB = parseFloat(b.total.replace(/[$|,]/g, ''))
      return crediAmountA > creditAmountB ? 1 : -1
    }, },
  { name: 'Monto Amount', key: 'totalNumber', omit: true, omitCSV: true, sort: true },
  { name: 'Banco $ Amount', key: 'bankCommissionAmountNumber', omit: true, omitCSV: true, sort: true },
]

const pendingColumns: ColumnConfig[] = [
  { name: 'Estatus', key: 'status', sort: true, width: '10%', component: PillCell },
  { name: 'Fecha Estimada', key: 'estimatedDate', sort: true, width: '10%' },
  { name: 'Banco', key: 'bank', sort: true, width: '10%' },
  { name: 'Cliente', key: 'client', sort: true, width: '15%' },
  { name: 'Banco Pagador', key: 'bankPayer', sort: true, width: '7.5%' },
  { name: 'Monto', key: 'total', sort: true, width: '10%' },
  { name: '% Comisión', key: 'bankCommissionPercentage', sort: true, width: '5%' },
  { name: '$ Comisión', key: 'bankCommissionAmount', sort: true, width: '5%' },
  { name: 'Monto Amount', key: 'totalNumber', omit: true, omitCSV: true, sort: true },
  { name: 'Banco $ Amount', key: 'bankCommissionAmountNumber', omit: true, omitCSV: true, sort: true },
]

const sentColumns: ColumnConfig[] = [
  { name: 'Estatus', key: 'status', sort: true, width: '10%', component: PillCell },
  { name: 'N de Factura', key: 'invoiceNumber', sort: true, width: '7.5%' },
  { name: 'Fecha Creación', key: 'invoiceDate', sort: true, width: '10%' },
  { name: 'Fecha De Pago', key: 'paymentDate', sort: true, width: '10%' },
  { name: 'Banco', key: 'bank', sort: true, width: '10%' },
  { name: 'Cliente', key: 'client', sort: true, width: '15%' },
  { name: 'Banco Pagador', key: 'bankPayer', sort: true, width: '7.5%' },
  { name: 'Monto', key: 'total', sort: true, width: '10%' },
  { name: '% Comisión', key: 'bankCommissionPercentage', sort: true, width: '5%' },
  { name: '$ Comisión', key: 'bankCommissionAmount', sort: true, width: '5%' },
  { name: 'Monto Amount', key: 'totalNumber', omit: true, omitCSV: true, sort: true},
  { name: 'Banco $ Amount', key: 'bankCommissionAmountNumber', omit: true, omitCSV: true, sort: true },
]

const paidColumns: ColumnConfig[] = [
  { name: 'Estatus', key: 'status', sort: true, width: '10%', component: PillCell },
  { name: 'N de Factura', key: 'invoiceNumber', sort: true, width: '7.5%' },
  { name: 'Fecha Creación', key: 'invoiceDate', sort: true, width: '10%' },
  { name: 'Fecha De Pago', key: 'paymentDate', sort: true, width: '10%' },
  { name: 'Fecha Marcada Pagada', key: 'markAsPaidDate', sort: true, width: '10%' },
  { name: 'Banco', key: 'bank', sort: true, width: '10%' },
  { name: 'Cliente', key: 'client', sort: true, width: '15%' },
  { name: 'Banco Pagador', key: 'bankPayer', sort: true, width: '7.5%' },
  { name: 'Monto', key: 'total', sort: true, width: '10%' },
  { name: '% Comisión', key: 'bankCommissionPercentage', sort: true, width: '5%' },
  { name: '$ Comisión', key: 'bankCommissionAmount', sort: true, width: '5%' },
  { name: 'Monto Amount', key: 'totalNumber', omit: true, omitCSV: true, sort: true },
  { name: 'Banco $ Amount', key: 'bankCommissionAmountNumber', omit: true, omitCSV: true, sort: true },
]

const invoiceColumnsMap: Record<string, ColumnConfig[]> = {
  analysis: analysisColumns,
  pending: pendingColumns,
  sent: sentColumns,
  paid: paidColumns,
}

export function getInvoiceColumns(status?: string): ColumnConfig[] {
  return invoiceColumnsMap[status || 'pending'] || pendingColumns
}
